
function Icon18(props) {
	
	return(
		<div className="icon-18 rounded-circle p-1">
			<span>-18</span>
		</div>
	);
}
export default Icon18;